import React from "react";

import {
  Button,
  Grid,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import PageHeader from "@ds-developer/page-header";

import { LadderImage } from "@hubcapp/components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 400,
    color: colors.blueGrey[500],
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
  image: {
    maxWidth: "100%",
    width: 560,
    maxHeight: 300,
    height: "auto",
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
}));

const ErrorGeneric = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PageHeader
        breadcrumbs={[{ title: "Error" }]}
        title="An error occurred"
      />

      <Typography variant="body1" className={classes.text}>
        This is awkward.
      </Typography>
      <Typography variant="body1" className={classes.text}>
        We experienced an error, please refresh the page to try to resolve the
        issue.
      </Typography>

      <Grid container justify="center" className={classes.imageContainer}>
        <LadderImage />
      </Grid>

      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="contained"
        >
          GO TO HOMEPAGE
        </Button>
      </div>
    </div>
  );
};

export default ErrorGeneric;
